import {
  styled,
  Typography,
  Button as BaseButton,
  Grid,
} from '@material-ui/core'

const BANNER_HEIGHT = 192
const BUTTON_HEIGHT = 38

export const Wrapper = styled(Grid)(({ theme }) => ({
  borderRadius: 20,
  height: BANNER_HEIGHT,
  boxSizing: 'border-box',
  position: 'relative',
  padding: theme.spacing(3, 2, 2.2, 4),
  overflow: 'hidden',
  background: `linear-gradient(108.32deg, ${theme.palette.primary.main} 15.14%, ${theme.palette.success.main} 105.5%)`,
}))

export const Button = styled(BaseButton)(({ theme }) => ({
  height: BUTTON_HEIGHT,
  borderRadius: 8,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,
  fontWeight: 600,
  fontSize: 16,
  paddingLeft: theme.spacing(6.5),
  paddingRight: theme.spacing(6.5),
}))

export const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '22px',
  marginBottom: theme.spacing(1.4),
}))

export const Title = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 28,
  lineHeight: '32px',
  marginBottom: theme.spacing(1),
}))

export const Image = styled('img')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: theme.spacing(1.5),
}))
